/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type CommentIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let CommentIcon: NessieFunctionComponent<CommentIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.049 3H8.91C5.089 3 2 6.374 2 10.48c0 3.78 2.52 6.87 5.894 7.398v3.415c0 .325.204.65.529.772.081.04.203.04.325.04a.896.896 0 00.61-.243l3.74-3.903h1.991c3.822 0 6.911-3.374 6.911-7.48C21.96 6.375 18.87 3 15.049 3zm-3.415 10.772H7.813a.407.407 0 010-.813h3.821a.407.407 0 010 .813zm4.512-2.723H7.772a.407.407 0 010-.813h8.374a.407.407 0 010 .813zm0-3.008H7.772a.407.407 0 010-.813h8.374a.407.407 0 010 .813z"
          />
          <mask maskUnits="userSpaceOnUse" x={2} y={3} width={20} height={20}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.049 3H8.91C5.089 3 2 6.374 2 10.48c0 3.78 2.52 6.87 5.894 7.398v3.415c0 .325.204.65.529.772.081.04.203.04.325.04a.896.896 0 00.61-.243l3.74-3.903h1.991c3.822 0 6.911-3.374 6.911-7.48C21.96 6.375 18.87 3 15.049 3zm-3.415 10.772H7.813a.407.407 0 010-.813h3.821a.407.407 0 010 .813zm4.512-2.723H7.772a.407.407 0 010-.813h8.374a.407.407 0 010 .813zm0-3.008H7.772a.407.407 0 010-.813h8.374a.407.407 0 010 .813z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
CommentIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  CommentIcon = nessiePropCheckerWrapper(CommentIcon);
}

export default CommentIcon;
